import { createClient } from '@/shared/api';
import type {
  UpdateStudyPatientMedicalHistoryMutation,
  UpdateStudyPatientMedicalHistoryMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_PATIENT_MEDICAL_HISTORY from '../mutations/updateStudyPatientMedicalHistory';

/**
 * Saves the patient's medical history on a study. Runs UPDATE_STUDY_PATIENT_MEDICAL_HISTORY and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyPatientMedicalHistory payload.
 */
const handleUpdateStudyPatientMedicalHistory = async (
  input: UpdateStudyPatientMedicalHistoryMutationVariables['input'],
): Promise<UpdateStudyPatientMedicalHistoryMutation['updateStudyPatientMedicalHistory']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyPatientMedicalHistoryMutation,
    UpdateStudyPatientMedicalHistoryMutationVariables
  >({
    mutation: UPDATE_STUDY_PATIENT_MEDICAL_HISTORY,
    variables: { input },
  });
  const { data } = result;
  const { updateStudyPatientMedicalHistory } = data ?? {};
  if (!updateStudyPatientMedicalHistory?.isSuccess) {
    throw new Error(updateStudyPatientMedicalHistory?.message ?? undefined);
  }
  return updateStudyPatientMedicalHistory;
};

export default handleUpdateStudyPatientMedicalHistory;
